import { CompanySize } from '../company/company-size.types';
import { Currency } from '../pricing/pricing.types';

export enum BillingPlanTier {
  Launch = 'launch',
  Scale = 'scale',
  Lead = 'lead',
  Start = 'start',
  Grow = 'grow',
  Optimize = 'optimize',
}

export enum PricingModel {
  Stairstep = 'stairstep',
  FlatFee = 'flat_fee',
}

export type BillingPeriod = 1 | 3 | 6 | 12 | 24 | 36;

export type Price = {
  basePrice: number;
  billingPeriodMonths: number;
  fteRangeEnd: number;
  fteRangeStart: number;
  kiwihrPlusPrice: number;
  onboardingPrice: number | null;
  ssoPrice: number;
  textingPrice: number;
};

export type BillingPlan = {
  id: number;
  basePrice?: number;
  baseSlots: number;
  billingPeriod: BillingPeriod;
  tier: BillingPlanTier;
  currency: Currency;
  pricing: Partial<
    Record<
      BillingPeriod,
      { slotPrice: number; basePrice: number; textingPrice: number; kiwihrPlusPrice: number }
    >
  >;
  pricingModel: PricingModel;
  prices: Price[];
  createdAt: number;
  custom: boolean;
  unlimited: boolean;
};

export type FteRange = CompanySize;
